import React from 'react';
import CurvedContainer from '../../components/CurvedContainer';
import { Images } from 'util/images';
import { useAppContext } from 'hooks/useContext';
import { Wrapper, Container, Button, SectionHeader, Link } from '../../components';
import * as strings from './strings';
import Path from '../../../routes/Path';

export default function NotFoundPage() {
  const { language } = useAppContext();

  return (
    <Wrapper>
      <CurvedContainer bottom height={110} image={Images.tanks} />
      <Container column center>
        <SectionHeader bold>404</SectionHeader>
        <SectionHeader>{strings.notFound[language]}</SectionHeader>
        <Link to={Path.landingPage}>
          <Button primary border>
            {strings.goHome[language]}
          </Button>
        </Link>
      </Container>
    </Wrapper>
  );
}
